module.exports = __webpack_public_path__ + "img/about2.690b7581.svg";